<template>
  <v-app>
    <v-content>
      <v-img :src="require('@/assets/background.svg')" height="100vh">
        <router-view></router-view>
      </v-img>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'App'
}
</script>
